import { Box, Card, CardActionArea, Stack, useTheme } from "@mui/material";
import { InternBrandStyleLogo_brand$data } from "./__generated__/InternBrandStyleLogo_brand.graphql";
import InternLogo from "./InternLogo";

export type BrandLogo = NonNullable<
  InternBrandStyleLogo_brand$data["internStyle"]
>["logos"][number];

type InternBrandStyleLogoItemProps = {
  index?: number;
  logo: BrandLogo;
  selectable?: boolean;
  isSelected?: boolean;
  onClick?: () => void;
  size?: "small" | "large";
  logoBackgroundColor?: string;
};

const InternBrandStyleLogoItem = ({
  index,
  logo,
  selectable = false,
  isSelected = false,
  onClick,
  size = "small",
  logoBackgroundColor,
}: InternBrandStyleLogoItemProps) => {
  const theme = useTheme();

  if (!selectable) {
    return (
      <Card
        sx={{
          p: size === "large" ? 3 : 2,
          backgroundColor: "white",
          border: "1px solid #E0E0E0",
          borderRadius: "12px",
          minHeight: size === "large" ? "200px" : "auto",
        }}
      >
        <InternLogo logo={logo} size={size} />
      </Card>
    );
  }

  return (
    <Card
      sx={{
        mb: 2,
        border: isSelected
          ? `2px solid ${theme.palette.primary.main}`
          : "1px solid #E0E0E0",
        borderRadius: "8px",
        backgroundColor: isSelected ? "#F8F9FF" : "white",
        transition: "all 0.2s ease",
        "&:hover": {
          borderColor: theme.palette.primary.main,
          backgroundColor: "#F8F9FF",
        },
      }}
    >
      <Stack direction="row" alignItems="center">
        {index !== undefined && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 24,
              height: 24,
              borderRadius: "50%",
              backgroundColor: theme.palette.primary.main,
              color: "white",
              fontSize: "12px",
              fontWeight: 600,
              marginLeft: 2,
              marginRight: 1,
              flexShrink: 0,
            }}
          >
            {index + 1}
          </Box>
        )}
        <CardActionArea
          onClick={onClick}
          sx={{ p: 2, flex: 1, backgroundColor: logoBackgroundColor }}
        >
          <InternLogo logo={logo} size={size} />
        </CardActionArea>
      </Stack>
    </Card>
  );
};

export default InternBrandStyleLogoItem;
